module.exports = __webpack_public_path__ + "img/logo_landing@3x.125d6747.png";